import { AccountEmailResponse, AccountEmailResponseItem } from '@/types/service-response'

export class AccountEmail {
  public constructor (
    readonly email: string,
    readonly isEdit: boolean
  ) {}

  static createFromResponse (responseData: AccountEmailResponse): AccountEmail[] {
    return responseData.map( (item: AccountEmailResponseItem): AccountEmail =>
      new AccountEmail(
        item.email,
        false
      )
    )
  }

  static createEmpty (): AccountEmail {
    return new AccountEmail(
        '',
        true
      )
  }

  public update (isEdit: boolean): AccountEmail {
    return new AccountEmail(
      this.email,
      isEdit
    )
  }
}

